// import { takeEvery, select, put } from 'redux-saga/effects';
import { REHYDRATE as rehydrateAction } from 'redux-persist/src/constants';
import { connect } from 'react-redux';
import { setAuth, initOptions } from '../api';
import { getToken, getIsAuthenticated } from '../selectors/authSelectors';
import { loadInitClientData } from '../actions/authActions';

function initAuth() {
  let isAuthenticated = this.props.isAuthenticated;
  if (isAuthenticated) {
    let token =  this.props.token;
    setAuth(token);
     loadInitClientData();
  }
  initOptions();
}

function  authThunk() {
  return rehydrateAction(initAuth());
}
function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: getIsAuthenticated(state),
    token: getToken(state)
  };
}

export default connect(mapStateToProps)(authThunk);

